<template>
    <v-treeview
        v-model="tree"
        :items="treeItems"
        item-key="id"
        open-on-click
        selected-color="indigo"
    >
        <template v-slot:append="{ item }">
            <v-btn
                v-if="item.class === 'type'"
                plain
                small
                color="success"
                @click="createItem(item)"
            >
                Create Category
                <v-icon>mdi-folder-plus</v-icon>
            </v-btn>
            <v-btn
                v-else-if="item.class === 'category'"
                plain
                small
                color="success"
                @click="createItem(item)"
            >
                Create Subcategory
                <v-icon>mdi-file-tree</v-icon>
            </v-btn>
            <v-btn
                icon
                small
                @click="editItem(item)"
                :disabled="item.class === 'type'"
            >
                <v-icon>mdi-rename</v-icon>
            </v-btn>
            <v-btn
                icon
                small
                @click="deleteItem(item)"
                :disabled="item.class === 'type'"
            >
                <v-icon>mdi-delete</v-icon>
            </v-btn>
        </template>
        <template v-slot:prepend="{ item, open }">
            <v-icon :color="item.color ? item.color : 'indigo'" v-if="!item.icon">
                <!--{{ open ? 'mdi-folder-open' : 'mdi-folder' }}-->
                {{
                    item.class === 'category'
                        ? 'mdi-folder'
                        : 'mdi-dots-vertical'
                }}
            </v-icon>
            <v-icon :color="item.color ? item.color : 'indigo'" v-else>
                {{ item.icon }}
            </v-icon>
        </template>
    </v-treeview>
</template>

<script>
import axios from 'axios';
export default {
    name: 'ExpenseTypeCategorySubcategory',
    components: {},
    props: {},
    data() {
        return {
            types: null,
            categories: null,
            subcategories: null,
            tree: [],
            treeItems: []
        };
    },
    computed: {
        authorization() {
            return {
                headers: {
                    Authorization: 'Bearer ' + this.$store.state.token
                }
            };
        }
    },
    mounted() {
        this.getTypesCategoriesSubcategories();
    },
    methods: {
        async getTypes() {
            return axios
                .get(
                    '/v2/maintenance/invoices/expenses/types',
                    this.authorization
                )
                .then(response => {
                    this.types = response.data;
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },
        async getCategories() {
            return axios
                .get(
                    '/v2/maintenance/invoices/expenses/categories',
                    this.authorization
                )
                .then(response => {
                    this.categories = response.data;
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },
        async getSubcategories() {
            return axios
                .get(
                    '/v2/maintenance/invoices/expenses/subcategories',
                    this.authorization
                )
                .then(response => {
                    this.subcategories = response.data;
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },
        groupTypesCategoriesSubcategories() {
            this.types.forEach(type => {
                type.class = 'type';
                type.icon ?? 'mdi-folder';
                type.children = this.categories.filter(
                    category => category.maintenance_expense_type_id === type.id
                );
                type.children.forEach(category => {
                    category.class = 'category';
                    category.icon ?? 'mdi-folder';
                    category.children = this.subcategories.filter(
                        subcategory =>
                            subcategory.maintenance_expense_category_id ===
                            category.id
                    );
                    category.children.forEach(subcategory => {
                        subcategory.class = 'subcategory';
                        subcategory.icon ?? 'mdi-folder';
                    });
                });
            });
            this.treeItems = this.types;
        },

        //await when all types categories and subcategories are loaded then execute the groupTypesCategoriesSubcategories
        async getTypesCategoriesSubcategories() {
            try {
                await this.getTypes();
                await this.getCategories();
                await this.getSubcategories();
                this.groupTypesCategoriesSubcategories();
            } catch (error) {
                console.log(error);
            }
        },

        createItem(item) {
            console.log(item);
            if (item.class === 'type') {
                let category = prompt('Enter category name');
                if (category) {
                    axios
                        .post(
                            '/v2/maintenance/invoices/expenses/categories',
                            {
                                name: category,
                                maintenance_expense_type_id: item.id
                            },
                            this.authorization
                        )
                        .then(response => {
                            console.log(response);
                            this.getTypesCategoriesSubcategories();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            } else if (item.class === 'category') {
                let subcategory = prompt('Enter subcategory name');
                if (subcategory) {
                    axios
                        .post(
                            '/v2/maintenance/invoices/expenses/subcategories',
                            {
                                name: subcategory,
                                maintenance_expense_category_id: item.id
                            },
                            this.authorization
                        )
                        .then(response => {
                            console.log(response);
                            this.getTypesCategoriesSubcategories();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            } else {
                console.error('Error invalid class');
            }
        },
        editItem(item) {
            console.log('Editing item: ', item);
            if (item.class === 'type') {
                let newName = prompt('Enter new name', item.name);
                if (newName) {
                    axios
                        .put(
                            `/v2/maintenance/invoices/expenses/types/${item.id}`,
                            {
                                name: newName
                            },
                            this.authorization
                        )
                        .then(response => {
                            console.log(response);
                            this.getTypesCategoriesSubcategories();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            } else if (item.class === 'category') {
                let newName = prompt('Enter new name', item.name);
                if (newName) {
                    axios
                        .put(
                            `/v2/maintenance/invoices/expenses/categories/${item.id}`,
                            {
                                name: newName
                            },
                            this.authorization
                        )
                        .then(response => {
                            console.log(response);
                            this.getTypesCategoriesSubcategories();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            } else if (item.class === 'subcategory') {
                let newName = prompt('Enter new name', item.name);
                if (newName) {
                    axios
                        .put(
                            `/v2/maintenance/invoices/expenses/subcategories/${item.id}`,
                            {
                                name: newName
                            },
                            this.authorization
                        )
                        .then(response => {
                            console.log(response);
                            this.getTypesCategoriesSubcategories();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            } else {
                console.error('Error invalid class');
            }
        },
        deleteItem(item) {
            console.log('Deleting item: ', item);
            if (item.class === 'type') {
                if (confirm('Are you sure you want to delete this type?')) {
                    axios
                        .delete(
                            `/v2/maintenance/invoices/expenses/types/${item.id}`,
                            this.authorization
                        )
                        .then(response => {
                            console.log(response);
                            this.getTypesCategoriesSubcategories();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            } else if (item.class === 'category') {
                if (confirm('Are you sure you want to delete this category?')) {
                    axios
                        .delete(
                            `/v2/maintenance/invoices/expenses/categories/${item.id}`,
                            this.authorization
                        )
                        .then(response => {
                            console.log(response);
                            this.getTypesCategoriesSubcategories();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            } else if (item.class === 'subcategory') {
                if (
                    confirm('Are you sure you want to delete this subcategory?')
                ) {
                    axios
                        .delete(
                            `/v2/maintenance/invoices/expenses/subcategories/${item.id}`,
                            this.authorization
                        )
                        .then(response => {
                            console.log(response);
                            this.getTypesCategoriesSubcategories();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            } else {
                console.error('Error invalid class');
            }
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title =
                    'Maintenance Expense - Type, Category and Subcategory';
            }
        }
    }
};
</script>
